// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3jXj6","largestCol":"styles_largestCol__yH7IZ","smallestCol":"styles_smallestCol__2N2YV"};